import React from 'react';

const NAV_ITEMS = [
  { id: 'home', key: 'home' },
  { id: 'services', key: 'services' },
  { id: 'team', key: 'team' },
  { id: 'clients', key: 'clients' },
  { id: 'contact', key: 'contact' },
];

export const CorporateNavbar = ({
  t,
  i18n,
  languages,
  isPortuguese,
  mobileMenuOpen,
  langMenuOpen,
  setMobileMenuOpen,
  setLangMenuOpen,
  onChangeLanguage,
  onScrollSection,
}) => {
  const currentLanguageFlag = languages.find((language) => language.code === i18n.language)?.flag || '🇧🇷';

  return (
    <nav className="fixed top-0 w-full bg-white shadow-md z-50" data-testid="home-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0" data-testid="home-navbar-brand">
            <h1 className="text-xl sm:text-2xl font-bold text-blue-600">RH Consulting Holdings</h1>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-testid="home-navbar-desktop-menu">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => onScrollSection(item.id)}
                className="text-gray-700 hover:text-blue-600 transition"
                data-testid={`home-nav-${item.id}-button`}
              >
                {t(`nav.${item.key}`)}
              </button>
            ))}

            <a
              href="/admin/login"
              className="text-gray-700 hover:text-blue-600 transition"
              data-testid="home-nav-restricted-link"
            >
              {isPortuguese ? 'Acesso restrito' : 'Restricted access'}
            </a>

            <div className="relative" data-testid="home-language-selector-desktop">
              <button
                onClick={() => setLangMenuOpen(!langMenuOpen)}
                className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition"
                data-testid="home-open-language-menu-button"
              >
                <span className="text-2xl" data-testid="home-current-language-flag">{currentLanguageFlag}</span>
              </button>

              {langMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50" data-testid="home-language-menu-desktop">
                  {languages.map((language) => (
                    <button
                      key={language.code}
                      onClick={() => onChangeLanguage(language.code)}
                      className={`w-full text-left px-4 py-2 hover:bg-blue-50 flex items-center space-x-3 ${
                        i18n.language === language.code ? 'bg-blue-100' : ''
                      }`}
                      data-testid={`home-language-option-${language.code}`}
                    >
                      <span className="text-2xl">{language.flag}</span>
                      <span>{language.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-blue-600 focus:outline-none"
            data-testid="home-mobile-menu-toggle-button"
          >
            <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              {mobileMenuOpen ? <path d="M6 18L18 6M6 6l12 12" /> : <path d="M4 6h16M4 12h16M4 18h16" />}
            </svg>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t" data-testid="home-mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {NAV_ITEMS.map((item) => (
              <button
                key={`mobile-${item.id}`}
                onClick={() => onScrollSection(item.id)}
                className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded"
                data-testid={`home-mobile-nav-${item.id}-button`}
              >
                {t(`nav.${item.key}`)}
              </button>
            ))}

            <a
              href="/admin/login"
              className="flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded"
              data-testid="home-mobile-nav-restricted-link"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c1.105 0 2-.895 2-2V7a2 2 0 10-4 0v2c0 1.105.895 2 2 2zm-7 9h14a2 2 0 002-2v-5a2 2 0 00-2-2H5a2 2 0 00-2 2v5a2 2 0 002 2z" />
              </svg>
              <span>{isPortuguese ? 'Acesso restrito' : 'Restricted access'}</span>
            </a>

            <div className="px-3 py-2 border-t" data-testid="home-language-selector-mobile">
              <p className="text-sm text-gray-500 mb-2">Language / 言語</p>
              <div className="grid grid-cols-4 gap-2" data-testid="home-mobile-language-grid">
                {languages.map((language) => (
                  <button
                    key={`mobile-lang-${language.code}`}
                    onClick={() => onChangeLanguage(language.code)}
                    className={`text-2xl p-2 rounded ${i18n.language === language.code ? 'bg-blue-100' : 'hover:bg-gray-100'}`}
                    data-testid={`home-mobile-language-option-${language.code}`}
                  >
                    {language.flag}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};
